import { createStore } from 'vuex'

const COMPANIES = ['Crow*', '36*', '易*', '伟*', '明*', '金宝*', '利*', '盈*', '18*', '平*', '12*', '澳*']
const LEAGUES = ['英超', '意甲', '西甲', '德甲', '法甲', '葡超', '苏超', '荷甲', '比甲', '英冠',
  '意乙', '西乙', '德乙', '法乙', '葡甲', '苏冠', '荷乙', '比乙', '英甲', '意杯',
  '西杯', '德丙', '法国杯', '葡杯', '苏总杯', '荷兰杯', '比利时杯', '英乙', '德国杯', '英足总杯',
  '英联杯', '瑞典超', '芬超', '挪超', '丹麦超', '奥甲', '瑞士超', '爱超', '俄超', '沙特联',
  '瑞典甲', '芬甲', '挪甲', '丹麦甲', '奥乙', '瑞士甲', '爱甲', '俄甲', '瑞典杯', '芬兰杯',
  '挪威杯', '丹麦杯', '奥地利杯', '瑞士杯', '俄杯', '波兰超', '乌克超', '捷甲', '希腊超', '罗甲',
  '冰岛超', '土超', '阿甲', '阿联酋超', '波兰甲', '土甲', '波兰杯', '土杯', '巴西甲', '美职业',
  '智利甲', '墨西联', '中超', '秘鲁甲', '日职联', '韩K联', '哥伦甲', '巴西乙', '日职乙', '韩K2联',
  '日联杯', '韩国杯', '日皇杯', '澳超', '埃及超', '卡塔尔联', '厄瓜甲', '印度超', '世界杯', '欧洲杯',
  '亚洲杯', '美洲杯', '澳足总', '欧洲预选', '欧冠杯', '亚冠精英', '解放者杯', '澳威超', '亚洲预选', '欧罗巴杯',
  '美金杯', '澳维超', '南美预选', '欧国联', '欧会杯', "意超杯", "西超杯", "德超杯", "英社盾", "法超杯", "葡超杯", "荷超杯", "比超杯", "瑞超杯", "挪超杯", "芬甲联杯", "芬联杯", "奥乙", "奥地利杯", "俄超杯", "罗杯", "匈甲", "土超杯", "塞浦甲", "塞尔超", "土伦杯", "国际友谊", "欧青U19", "欧青U21"
]
const LEAGUE_MAP = {
  '英格兰': ['全部', '英超', '英冠', '英甲', '英乙', '英足总杯', '英联杯'],
  '意大利': ['全部', '意甲', '意乙', '意杯'],
  '西班牙': ['全部', '西甲', '西乙', '西杯'],
  '德国': ['全部', '德甲', '德乙', '德丙', '德国杯'],
  '法国': ['全部', '法甲', '法乙', '法国杯'],
  '葡萄牙': ['全部', '葡超', '葡甲', '葡杯'],
  '苏格兰': ['全部', '苏超', '苏冠', '苏总杯'],
  '荷兰': ['全部', '荷甲', '荷乙', '荷兰杯'],
  '比利时': ['全部', '比甲', '比乙', '比利时杯'],
  '瑞典': ['全部', '瑞典超', '瑞典甲', '瑞典杯'],
  '芬兰': ['全部', '芬超', '芬甲', '芬兰杯'],
  '挪威': ['全部', '挪超', '挪甲', '挪威杯'],
  '丹麦': ['全部', '丹麦超', '丹麦甲', '丹麦杯'],
  '奥地利': ['全部', '奥甲', '奥乙', '奥地利杯'],
  '瑞士': ['全部', '瑞士超', '瑞士甲', '瑞士杯'],
  '爱尔兰': ['全部', '爱超', '爱甲'],
  '俄罗斯': ['全部', '俄超', '俄甲', '俄杯'],
  '沙特阿拉伯': ['沙特联'],
  '波兰': ['全部', '波兰超', '波兰甲', '波兰杯'],
  '乌克兰': ['乌克超'],
  '捷克': ['捷甲'],
  '希腊': ['希腊超'],
  '罗马尼亚': ['罗甲'],
  '冰岛': ['冰岛超'],
  '土耳其': ['全部', '土超', '土甲', '土杯'],
  '阿根廷': ['阿甲'],
  '阿联酋': ['阿联酋超'],
  '巴西': ['全部', '巴西甲', '巴西乙'],
  '美国': ['美职业'],
  '智利': ['智利甲'],
  '墨西哥': ['墨西联'],
  '中国': ['中超'],
  '秘鲁': ['秘鲁甲'],
  '日本': ['全部', '日职联', '日职乙', '日联杯', '日皇杯'],
  '韩国': ['全部', '韩K联', '韩K2联', '韩国杯'],
  '哥伦比亚': ['哥伦甲'],
  '澳大利亚': ['全部', '澳超', '澳足总', '澳威超', '澳维超'],
  '埃及': ['埃及超'],
  '卡塔尔': ['卡塔尔联'],
  '厄瓜多尔': ['厄瓜甲'],
  '印度': ['印度超'],
  '欧洲': ['全部', '欧洲杯', '欧洲预选', '欧冠杯', '欧罗巴杯', '欧国联', '欧会杯'],
  '亚洲': ['全部', '亚洲杯', '亚洲预选', '亚冠精英',],
  '美洲': ['全部', '美洲杯', '南美预选', '美金杯', '解放者杯'],
  '国际赛事': ['世界杯']
}
const GAME_BREAK_POINTS = ["0分钟", "5分钟", "10分钟", "15分钟", "20分钟", "25分钟", "30分钟",
  "45分钟", "60分钟", "75分钟", "90分钟", "120分钟", "150分钟", "180分钟",
  "210分钟", "240分钟", "270分钟", "300分钟", "330分钟", "360分钟"]

const CROWN_WATER_TIMES = ["12:00", "12:30", "13:00", "13:30", "14:00", "14:30",
  "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
  "18:00", "18:30", "19:00", "19:30", "20:00", "20:30",
  "21:00", "21:30", "22:00", "22:30", "23:00", "23:30",
  "00:00", "00:30", "01:00", "01:30", "02:00", "02:30",
  "03:00", "03:30", "04:00", "04:30", "05:00", "05:30",
  "06:00", "06:30", "07:00", "07:30", "08:00", "08:30",
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30"]

/**
 * 获取今日0点往前n天的时间
 * @param {number} n - 往前推的天数 (0 表示今天)
 * @returns {Date} 对应日期的 0 点
 */
function getZeroDateNDaysAgo(n) {
  const now = new Date();
  // 直接构造 0 点的日期
  const date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  // 往前推 n 天
  date.setDate(date.getDate() - n);
  return date;
}

function getDateFromYMD(year, month, day) {
  // 月份需要减1，因为JavaScript中月份是从0开始（0=1月，11=12月）
  return new Date(year, month - 1, day);
}

const NEWBALL_WEEKLY_DEFAULT_START_DATE = getDateFromYMD(2026, 1, 12)
const NEWBALL_WEEKLY_DEFAULT_END_DATE = new Date(NEWBALL_WEEKLY_DEFAULT_START_DATE.getTime())
NEWBALL_WEEKLY_DEFAULT_END_DATE.setDate(NEWBALL_WEEKLY_DEFAULT_END_DATE.getDate() + 27)

export default createStore({
  state: {
    networkConfig: {
      is_dev: process.env.NODE_ENV === "development",
    },
    // 下单数据参数
    order_data: {
      startDate: getZeroDateNDaysAgo(7),
      endDate: getZeroDateNDaysAgo(0),
      pageIndex: 1,
      order_records: [],
      pre_btn_enable: false,
      next_btn_enable: false,
    },
    // 实时下单数据
    realtime_order_data: [],
    team_match: {
      unmatch_crown_league: [],
      unmatch_crown_team: [],
      unmatch_pb_leagus: [],
      unmatch_pb_team: [],
      selected_crown_league: [],
      selected_crown_team: [],
      selected_pb_league: [],
      selected_pb_team: []
    },
    spider_status: "未启动",
    spider_button_status: {
      start_btn_disable: false,
      crawl_btn_disable: false,
      stop_btn_disable: false
    },
    spider_config: {
      trigger_buy_water: 0.0,
      crown_proportion: 0.0,
      pb_proportion: 0.0,
    },
    newball_ip_status: [],
    newball: {
      selected_league: "中超",
      selected_company: COMPANIES[0],
      selected_start_date: getDateFromYMD(2025, 5, 1),
      selected_end_date: getDateFromYMD(2025, 5, 2),
      selected_break_point: GAME_BREAK_POINTS[0],
      page_index: 1,
      page_size: 20,
      serve_total_count: 0,
      serve_total_page: 0,
      serverData: [],
      currentstep: 1,
      companies: COMPANIES,
      leagues: LEAGUES,
      game_break_points: GAME_BREAK_POINTS,
      // 公司页面参数
      company_page_param: {
        league: "",
        gametime: new Date(),
        home: "",
        away: "",
      },
      // 详情页面参数
      detail_page_param: {
        league: "",
        gametime: new Date(),
        home: "",
        away: "",
        company: "",
        odd: ""
      },
      // 新球-皇冠水位
      crown_water: {
        region: Object.keys(LEAGUE_MAP)[0],
        regions: LEAGUE_MAP,
        leagues: LEAGUES,
        times: GAME_BREAK_POINTS,
        league: LEAGUE_MAP[Object.keys(LEAGUE_MAP)[0]][0], // 联赛
        start_date: getZeroDateNDaysAgo(30),
        end_date: getZeroDateNDaysAgo(0),
        start_time: CROWN_WATER_TIMES[0], // 开始筛选日期
        end_time: CROWN_WATER_TIMES[1], // 结束筛选日期
        part1_time: GAME_BREAK_POINTS[11], // 阶段1开始时间
        part2_time: GAME_BREAK_POINTS[8], // 阶段2开始时间
        part3_time: GAME_BREAK_POINTS[4], // 阶段3开始时间
        water: "3", // 阶段1筛选水位
        water2: "2", // 阶段2筛选水位
        water_datas: [], // 服务器结果
        total_page: 0, // 总页数
        total_count: 0, // 总记录数
        page_index: 1, // 当前页码
        page_size: 20, // 每页记录数
        summary: {}
      }
    },
    // 新球即时数据
    newball_realtime_data: {
      activeIndex: "1",
      // 1. 积分界面参数
      selectedDate: getZeroDateNDaysAgo(2),
      pointDatas: [],
      // 2. 盘口积分参数
      pkDetailParam: null,
      pkPointsDatas: [],
      // 3. 详细积分参数
      showPrematchDetail: false,
      prematchDetailParam: null,
      prematchData: [],
      prematchDetaiDataList: [],
      // 匹配次数参数
      selected_company: "利*",
      // 匹配次数结果
      match_count_datas: [],
      // 4. 多公司积分参数
      // 赛前时间
      before_game_time: 180,
      multi_start_date: getZeroDateNDaysAgo(14),
      multi_end_date: getZeroDateNDaysAgo(0),
      multi_pre_gametime: "全部",
      multi_match_water: 1.95,
      multicompanyDatas: [],
      multicompany_first_detail_param: null,
      multicompany_second_detail_param: null,
      // 5. 公司次数参数
      start_date: getZeroDateNDaysAgo(56),
      end_date: getZeroDateNDaysAgo(1),
      company_count_companies: [],
      company_count_selected_company: "利*",
      company_count_selected_count: "全部",
      company_count_selected_pre_gametime: "全部",
      company_count_selected_match_water: 1.95,
      company_count_datas: [],
      // 第二页面参数
      company_count_second_param: null,
      // 第三页面参数
      company_count_third_param: null,
      // 多公司正分相关参数
      // 选项
      multi_positive_selected_options: [],
      multi_positive_pre_gametime: "180",
      multi_positive_match_water: 1.95,
      // 多公司正分结果
      multi_positive_datas: [],
      // 多公司正分第一详情页参数
      multi_positive_first_detail_param: null,
      // 多公司正分第二详情页参数
      multi_positive_second_detail_param: null,
      // 多公司负分相关参数
      // 选项
      multi_negative_selected_options: [],
      multi_negative_pre_gametime: "180",
      multi_negative_match_water: 1.95,
      // 多公司负分结果
      multi_negative_datas: [],
      // 多公司负分第一详情页参数
      multi_negative_first_detail_param: null,
      // 多公司负分第二详情页参数
      multi_negative_second_detail_param: null,
    },
    newball_immediate_data: {
      // 1. tab下标
      tab_active_index: "1",
      realtime_collecting: null,
      // 2. 即时数据
      realtime_now_data: [],
      now_data_detail_page_param: null,
      now_data_pre_gametime: "全部",
      // 3. 手动下单参数
      manual_company: "利*",
      manual_table_data: [],
      // 详情页面
      manual_detail_page_param: null,
      // 4. 正分参数
      manual_positive_companies: [],
      // 详情页面
      manual_positive_detail_page_param: null,
      // 5. 负分参数
      manual_negative_companies: [],
      manual_negative_table_data: [],
      // 详情页面
      manual_negative_detail_page_param: null,
    },
    // 新球趋势数据
    newball_trend_data: {
      selected_company: "利*",
      period: 7, // 周期：按天计算
      trend_datas: [],
      loading: false, // 添加loading状态
      start_date: getZeroDateNDaysAgo(56), // 默认开始日期：8周前
      end_date: getZeroDateNDaysAgo(1), // 默认结束日期：昨天天
      match_water: "无",
      pre_time: "无",
      // 详情页1参数
      trend_second_detail_param: null,
      // 详情页2参数
      trend_third_detail_param: null,
      // 按日期查询的数据结果
      date_based_data: null,
    },
    newball_weekly_data: {
      companies: [],
      table_data: [],
      start_date: NEWBALL_WEEKLY_DEFAULT_START_DATE,
      end_date: NEWBALL_WEEKLY_DEFAULT_END_DATE
    },
    order_detail_selected_account_id: null,
    account_history_selected_account_id: null,
    waiting_order_selected_account_id: null,
  },
  getters: {
    baseurl(state) {
      const configured = (process.env.VUE_APP_BASEURL || "").trim();
      if (configured) return configured;

      const loc = (typeof window !== "undefined" && window.location) ? window.location : null;
      const hostname = (loc && loc.hostname) ? loc.hostname : "";
      const origin = (loc && typeof loc.origin === "string") ? loc.origin : "";
      const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
      if (state.networkConfig.is_dev || isLocal) {
        return "http://localhost:5555";
      }
      if (origin && origin !== "null") {
        return origin;
      }
      if (hostname) {
        return `https://${hostname}`;
      }
      return "https://154.23.186.148";
    }
  },
  mutations: {
    setOrderDetailSelectedAccountId(state, val) {
      state.order_detail_selected_account_id = val
    },
    setAccountHistorySelectedAccountId(state, val) {
      state.account_history_selected_account_id = val
    },
    setWaitingOrderSelectedAccountId(state, val) {
      state.waiting_order_selected_account_id = val
    },
    setCurrentStep(state, val) {
      state.newball.currentstep = val
    },
    // 新球即时数据参数
    setRealtimeActiveIndex(state, val) {
      state.newball_realtime_data.activeIndex = val
    },
    setRealtimeSelectedDate(state, val) {
      state.newball_realtime_data.selectedDate = val
    },
    setRealtimePointDatas(state, val) {
      state.newball_realtime_data.pointDatas = val
    },
    setRealtimePkDetailParam(state, val) {
      state.newball_realtime_data.pkDetailParam = val
    },
    setRealtimePkPointsDatas(state, val) {
      state.newball_realtime_data.pkPointsDatas = val
    },
    setRealtimePrematchData(state, val) {
      state.newball_realtime_data.prematchData = val
    },
    setRealtimePrematchDetailParam(state, val) {
      state.newball_realtime_data.prematchDetailParam = val
    },
    setRealtimePrematchDetaiDataList(state, val) {
      state.newball_realtime_data.prematchDetaiDataList = val
    },
    // 匹配次数参数
    setRealtimeSelectedCompany(state, val) {
      state.newball_realtime_data.selected_company = val
    },
    // 匹配次数结果
    setRealtimeMatchCountDatas(state, val) {
      state.newball_realtime_data.match_count_datas = val
    },
    // 4. 多公司积分参数
    setRealtimeMultiStartDate(state, val) {
      state.newball_realtime_data.multi_start_date = val
    },
    setRealtimeMultiEndDate(state, val) {
      state.newball_realtime_data.multi_end_date = val
    },
    setRealtimeMultiPreGametime(state, val) {
      state.newball_realtime_data.multi_pre_gametime = val
    },
    setRealtimeMultiMatchWater(state, val) {
      state.newball_realtime_data.multi_match_water = val
    },
    setRealtimeMulticompanyDatas(state, val) {
      state.newball_realtime_data.multicompanyDatas = val
    },
    setRealtimeBeforeGameTime(state, val) {
      state.newball_realtime_data.before_game_time = val
    },
    setRealtimeMulticompanyFirstDetailParam(state, val) {
      state.newball_realtime_data.multicompany_first_detail_param = val
    },
    setRealtimeMulticompanySecondDetailParam(state, val) {
      state.newball_realtime_data.multicompany_second_detail_param = val
    },
    // 5. 公司次数参数
    setRealtimeStartDate(state, val) {
      state.newball_realtime_data.start_date = val
    },
    setRealtimeEndDate(state, val) {
      state.newball_realtime_data.end_date = val
    },
    setRealtimeCompanyCountCompanies(state, val) {
      state.newball_realtime_data.company_count_companies = val
    },
    setRealtimeCompanyCountSelectedCompany(state, val) {
      state.newball_realtime_data.company_count_selected_company = val
    },
    setRealtimeCompanyCountDatas(state, val) {
      state.newball_realtime_data.company_count_datas = val
    },
    setRealtimeCompanyCountSecondParam(state, val) {
      state.newball_realtime_data.company_count_second_param = val
    },
    setRealtimeCompanyCountThirdParam(state, val) {
      state.newball_realtime_data.company_count_third_param = val
    },
    setRealtimeCompanyCountSelectedCount(state, val) {
      state.newball_realtime_data.company_count_selected_count = val
    },
    setRealtimeCompanyCountSelectedPreGametime(state, val) {
      state.newball_realtime_data.company_count_selected_pre_gametime = val
    },
    setRealtimeCompanyCountSelectedMatchWater(state, val) {
      state.newball_realtime_data.company_count_selected_match_water = val
    },
    // 多公司正分相关参数
    // 选项
    setRealtimeMultiPositiveSelectedOptions(state, val) {
      state.newball_realtime_data.multi_positive_selected_options = val
    },
    setRealtimeMultiPositivePreGameTime(state, val) {
      state.newball_realtime_data.multi_positive_pre_gametime = val
    },
    setRealtimeMultiPositiveMatchWater(state, val) {
      state.newball_realtime_data.multi_positive_match_water = val
    },
    // 多公司正分结果
    setRealtimeMultiPositiveDatas(state, val) {
      state.newball_realtime_data.multi_positive_datas = val
    },
    // 多公司正分第一详情页参数
    setRealtimeMultiPositiveFirstDetailParam(state, val) {
      state.newball_realtime_data.multi_positive_first_detail_param = val
    },
    // 多公司正分第二详情页参数
    setRealtimeMultiPositiveSecondDetailParam(state, val) {
      state.newball_realtime_data.multi_positive_second_detail_param = val
    },
    // 多公司负分相关参数
    // 选项
    setRealtimeMultiNegativeSelectedOptions(state, val) {
      state.newball_realtime_data.multi_negative_selected_options = val
    },
    setRealtimeMultiNegativePreGameTime(state, val) {
      state.newball_realtime_data.multi_negative_pre_gametime = val
    },
    setRealtimeMultiNegativeMatchWater(state, val) {
      state.newball_realtime_data.multi_negative_match_water = val
    },
    // 多公司负分结果
    setRealtimeMultiNegativeDatas(state, val) {
      state.newball_realtime_data.multi_negative_datas = val
    },
    // 多公司负分第一详情页参数
    setRealtimeMultiNegativeFirstDetailParam(state, val) {
      state.newball_realtime_data.multi_negative_first_detail_param = val
    },
    // 多公司负分第二详情页参数
    setRealtimeMultiNegativeSecondDetailParam(state, val) {
      state.newball_realtime_data.multi_negative_second_detail_param = val
    },

    /*   ⏰ 即时数据栏目参数   */
    // 即时数据tab下标
    setImmediateDataTabActiveIndex(state, val) {
      state.newball_immediate_data.tab_active_index = val
    },
    // 6. 即时数据
    setRealtimeNowData(state, val) {
      state.newball_immediate_data.realtime_now_data = val
    },
    setRealtimeNowDataDetailPageParam(state, val) {
      state.newball_immediate_data.now_data_detail_page_param = val
    },
    setRealtimeNowDataPreGametime(state, val) {
      state.newball_immediate_data.now_data_pre_gametime = val
    },
    // 7. 手动下单参数
    setRealtimeManualCompany(state, val) {
      state.newball_immediate_data.manual_company = val
    },
    setRealtimeManualTableData(state, val) {
      state.newball_immediate_data.manual_table_data = val
    },
    setRealtimeManualDetailPageParam(state, val) {
      state.newball_immediate_data.manual_detail_page_param = val
    },
    // 4. 正分参数
    setRealtimeManualPositiveCompanies(state, val) {
      state.newball_immediate_data.manual_positive_companies = val
    },
    setRealtimeManualPositiveTableData(state, val) {
      state.newball_immediate_data.manual_positive_table_data = val
    },
    // 详情页面
    setRealtimeManualPositiveDetailPageParam(state, val) {
      state.newball_immediate_data.manual_positive_detail_page_param = val
    },
    // 4. 负分参数
    setRealtimeManualNegativeCompanies(state, val) {
      state.newball_immediate_data.manual_negative_companies = val
    },
    setRealtimeManualNegativeTableData(state, val) {
      state.newball_immediate_data.manual_negative_table_data = val
    },
    // 详情页面
    setRealtimeManualNegativeDetailPageParam(state, val) {
      state.newball_immediate_data.manual_negative_detail_page_param = val
    },
    setNewballRealtimeCollecting(state, val) {
      state.newball_immediate_data.realtime_collecting = val
    },
    /*   ⏰ 即时数据栏目参数   */

    /* ⚽️ 新球趋势数据 */
    setNewballTrendSelectedCompany(state, val) {
      state.newball_trend_data.selected_company = val
    },
    setNewballTrendPeriod(state, val) {
      state.newball_trend_data.period = val
    },
    setNewballTrendDatas(state, val) {
      state.newball_trend_data.trend_datas = val
    },
    // 添加loading状态mutation
    setNewballTrendLoading(state, val) {
      state.newball_trend_data.loading = val
    },
    // 详情页1参数
    setNewballTrendSecondDetailParam(state, val) {
      state.newball_trend_data.trend_second_detail_param = val
    },
    // 详情页2参数
    setNewballTrendThirdDetailParam(state, val) {
      state.newball_trend_data.trend_third_detail_param = val
    },
    // 开始日期和结束日期
    setNewballTrendStartDate(state, val) {
      state.newball_trend_data.start_date = val
    },
    setNewballTrendEndDate(state, val) {
      state.newball_trend_data.end_date = val
    },
    setNewballTrendMatchWater(state, val) {
      state.newball_trend_data.match_water = val
    },
    setNewballTrendPreTime(state, val) {
      state.newball_trend_data.pre_time = val
    },
    // 按日期查询的数据结果
    setNewballTrendDateBasedData(state, val) {
      state.newball_trend_data.date_based_data = val
    },
    /* ⚽️ 新球趋势数据 */

    setNewballWeeklyCompanies(state, val) {
      state.newball_weekly_data.companies = val
    },
    setNewballWeeklyTableData(state, val) {
      state.newball_weekly_data.table_data = val
    },
    setNewballWeeklyStartDate(state, val) {
      state.newball_weekly_data.start_date = val
    },
    setNewballWeeklyEndDate(state, val) {
      state.newball_weekly_data.end_date = val
    },
  },
  actions: {
  },
  modules: {
  }
})
